import style from "./confirmDeletePopup.module.scss";

const ConfirmDeletePopup = ({active, onCancel, onConfirm}) => {
    if (!active) return null;

    return (
        <div
            className={style.backdrop}
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) onCancel();
            }}
        >
            <div className={style.dialog} role="alertdialog" aria-modal="true" aria-labelledby="confirm-delete-title">
                <div className={style.title} id="confirm-delete-title">{active.title}</div>
                <div className={style.message}>{active.message}</div>
                <div className={style.actions}>
                    <button type="button" className={style.cancel} onClick={onCancel}>Отмена</button>
                    <button type="button" className={style.confirm} onClick={onConfirm}>Удалить</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeletePopup;
